import './App.css';
import Divider from './attachment/Divider';
import Navbar from './attachment/Navbar';
import About from './pages/About';
import Home from './pages/Home';
import Project from './project/Project';

function App() {
  let component
  switch (window.location.pathname) {
    case "/about":
      component = <About />;
      break
    case "/home":
      component = <Home />;
      break
    default:
      component = <Home />;
      break
  }
  return (
    <div className="App">
      <Navbar />
      { component }
      <Divider />
      <Project />
    </div>
  );
}

export default App;
